<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="65%" @close="handleCancel">
    <AddSize
      v-if="dialogVisible"
      ref="addSizeRef"
      :shopList="shopList"
      :templateList="templateList"
      :specifications="specifications"
      :categoryId="categoryId"
      :showGenerateBtn="showGenerateBtn"
      :checkSize="checkSize"
      :previewTemplateInfo="previewTemplateInfo"
      :componentTemplateRule="componentTemplateRule"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addOrUpdateSizeTemplate } from '@/servers/prod/center/fxg.js';
import AddSize from './addSize.vue';
import _ from 'lodash';

export default {
  props: {
    checkSize: Boolean,
    sizeType: Number,
    shopList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    templateList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    specifications: {
      type: Array,
      default: () => {
        return [];
      },
    },
    categoryId: {
      type: [Number, String],
      default: '',
    },
    showGenerateBtn: {
      type: Boolean,
      default: false,
    },
    componentTemplateRule: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    AddSize,
  },
  data() {
    return {
      dialogVisible: false,
      previewTemplateInfo:{},
      title:'添加尺码信息',
      dialogType:'',
    };
  },
  unmounted() {
    this.previewTemplateInfo = {}
  },

  methods: {
    handleCancel() {
      this.clearTemplateConfig();
      this.dialogVisible = false;
    },
    method_open({previewTemplateInfo,dialogType}) {
      this.dialogVisible = true;
      this.previewTemplateInfo = previewTemplateInfo
      this.dialogType = dialogType
      // 针对预览数据进行标题更新
      if(this.previewTemplateInfo && this.previewTemplateInfo.templateInfo && this.dialogType == 'edit'){
        this.title = '编辑尺码信息'
      } else if(this.previewTemplateInfo && this.previewTemplateInfo.templateInfo){
        this.title = '预览尺码信息'
      } else {
        this.title = '添加尺码信息'
      }
    },
    async handleConfirm() {
      if(this.previewTemplateInfo && this.previewTemplateInfo.shopId && this.dialogType !='edit'){
        this.dialogVisible = false;
        return
      }
      let params = await this.$refs.addSizeRef.method_getData();
      if (!params) return;
      if(this.sizeType == 3 ){
        params.bizType = 2
      }
      if(this.sizeType == 1 ){
        params.bizType = 1
      }
      const res = await addOrUpdateSizeTemplate(params);
      if (!res) return;
      this.$emit('sizeTemplate', res);
      this.handleCancel();
    },
    clearTemplateConfig() {
      this.$refs.addSizeRef?.clearTemplateConfig();
    },
    clearShopId() {
      this.$refs.addSizeRef?.clearShopId();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
